// import React from 'react'

// const PurchaseApprovalPending = () => {
//   return (
//     <div>PurchaseApprovalPending</div>
//   )
// }

// export default PurchaseApprovalPending



import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";


import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../Modal/TableDataViewModal";
import actions from "../../../../ReduxStore/actions";
import TableDataViewModal from "../../../Operator/Modal/TableDataViewModal";
import ShemeApprovalModalView from "./Modal/ShemeApprovalModalView";
import { useEffect, useState } from "react";
import { format } from "date-fns";
// import { setHeaderName } from './headerSlice';

const SchemeApprovalReject = ({ setHeaderTitleName }) => {
  //   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  //   const UserRole = sessionStorage.getItem("UserRole");

  //    const customerId = useSelector((state) => state.customer);

  //    console.log(customerId,"customerIdcustomerIdcustomerIdcustomerId");


  //   const { managementRegisterForCustomer } = useSelector(
  //     (state) => state?.managementRegisterForCustomer
  //   );
  //   const dispatch = useDispatch();
  //   const { getCustomersByCreator } = useSelector(
  //     (state) => state?.getCustomersByCreator
  //   );

  // console.log(getCustomersByCreator,"getCustomersByCreatorgetCustomersByCreator")

  //   useEffect(() => {
  //     const data1 = {
  //       data: {
  //         createdByUserId: sessionOperator_id,
  //         createdByUserRole: UserRole,
  //       },
  //       method: "get",
  //       apiName: "getCustomersByCreator",
  //     };

  //     dispatch(actions.GETCUSTOMERSBYCREATOR(data1));
  //   }, [managementRegisterForCustomer]);

  //   const [rowTableData, setRowTableData] = useState([
  //     {
  //       Name: "--",
  //       CustomerId:"--",
  //       Email: "--",
  //       MobileNumber: "--",
  //       UserType: "--",
  //       Status: "--",
  //     },
  //   ]);
  //   console.log(rowTableData, "rowTableDatarowTableData");
  //   useEffect(() => {
  //     const tempArr = [];
  //     getCustomersByCreator?.data?.map((data, index) => {
  //       return tempArr.push({
  //         Name: `${data?.first_name} ${data?.last_name}` || "--",
  //         customer_id:data?.customer_id || "--",
  //         Email: data?.email || "--",
  //         MobileNumber: data?.phone || "--",
  //         UserType: data?.role ? data?.role : "--",
  //         Status:
  //           data?.approval_status === "pending"
  //             ? "Pending"
  //             : data?.approval_status === "approved"
  //             ? "Approved"
  //             : "Unknown" || "--", // Add a default case if needed

  //       });   
  //     });
  //     setRowTableData(tempArr);
  //   }, [dispatch, getCustomersByCreator]);


  //   useEffect(() => {
  //     // setHeaderTitleName("User Registration")
  //     dispatch(setHeaderName("User Registration"));
  //   }, []);

  const dispatch = useDispatch();
  const { getAllRejectedPlansWithCreatorAndRejector } = useSelector(
    (state) => state?.getAllRejectedPlansWithCreatorAndRejector
  );

  console.log(getAllRejectedPlansWithCreatorAndRejector, "getAllPendingPlansWithCreatorgetAllPendingPlansWithCreator")

  useEffect(() => {
    const data1 = {
      data: {},
      method: "get",
      apiName: "getAllRejectedPlansWithCreatorAndRejector",
    };

    dispatch(actions.GETALLREJECTEDPLANSWITHCREATORANDREJECTOR(data1));
  }, []);


  const [rowTableData, setRowTableData] = useState([
    {
      title: "--",
      Value: "--",
      Stake: "--",
      Maturity: "--",
      LockIn: "--",
      Closure: "--",
      ReapPercentage: "--",
      reapMonths: "--",
      Status: "--",
    },
  ]);
  //   console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getAllRejectedPlansWithCreatorAndRejector?.data?.map((data, index) => {
      return tempArr.push({
        title: data?.title,
        // Value: data?.value_of_purchase,
        // plan_id: data?.plan_id,
        // Stake: data?.purchase_stake,
        // Maturity: data?.maturity_in_months,
        // LockIn: data?.lock_in_months,
        // Closure: format(new Date(data?.closure_date), 'MMMM d, yyyy'),
        // ReapPercentage: data?.reap_percentage,
        // reapMonths: data?.reap_months,
        Value: `${data?.value_of_purchase} USD`,
        plan_id: data?.plan_id,
        Stake: `${data?.purchase_stake} g`,
        Maturity: `${data?.maturity_in_months} Months`,
        LockIn: `${data?.lock_in_months} Months`,
        Closure: format(new Date(data?.closure_date), 'MMMM d, yyyy'),
        ReapPercentage: `${data?.reap_percentage} %`,
        reapMonths: `${data?.reap_months} Months`,
        creatorRole: data?.creatorRole?.roleName,
        creator: data?.creator?.name,
        rejectorRole: data?.rejectorRole?.roleName,
        rejector: data?.rejector?.name,
        Status: `${data?.approval_status} by ${data?.rejectorRole?.roleName}`,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getAllRejectedPlansWithCreatorAndRejector]);


  const tableData = [
    { title: 'Scheme 1', Value: '$1000', Stake: '13.8g', Maturity: '24 Months', LockIn: "24 Months", Closure: "15/Mar/2025", ReapPercentage: "50%", reapMonths: "12 months", Status: "Reject" },
    { title: 'Scheme 1', Value: '$1000', Stake: '13.8g', Maturity: '24 Months', LockIn: "24 Months", Closure: "15/Mar/2025", ReapPercentage: "50%", reapMonths: "12 months", Status: "Reject" },

  ];
  const tableHeadData = ['S.No', 'Title', "Value", 'Stake', 'Maturity', "Lock In", "Closure date", "Reap(%)", "Reap months", "Creator Role", "Creator Name", "rejector Role", "rejector Name", "Status"];


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          //   title="User List"
          title="Scheme Approval-Gold Stake"

          tableHeadData={tableHeadData}
          //   modalName={UserCreateByOperatorModal}
          allShowModal="allShowModal"
          modalVeiwName={ShemeApprovalModalView}
          //   notModalTable="notModalTable"
          //   tableEdit="tableEdit"
          tableView="tableView"
          modalViewHeadingName="Scheme Approval"
          modalHeadingName="Create User"
          // dataCreate="dataCreate"
          isRejectTextShowModal="isRejectTextShowModal"
        />
      </Grid>
    </Grid>
  );
};

export default SchemeApprovalReject;
